import { CustomFunction } from "@ceeferenderer/itg-renderer-sdk/model/common";
import { ICustomFunctionValueType } from "@ceeferenderer/itg-renderer-sdk";

type Validator = (value: ICustomFunctionValueType, input?: Element) => boolean;

export const buildValidator =
  (message: string, validator: Validator): CustomFunction =>
  (value, _, input) => ({
    message: input?.getAttribute("data-validation-message") || message,
    value: validator(value, input),
  });
